import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { createPortal } from 'react-dom';
import { LeafletProvider } from './context.js';
export function createContainerComponent(useElement) {
  function ContainerComponent(props, forwardedRef) {
    var _useElement$current = useElement(props).current,
        instance = _useElement$current.instance,
        context = _useElement$current.context;
    useImperativeHandle(forwardedRef, function () {
      return instance;
    });
    return props.children == null ? null : /*#__PURE__*/React.createElement(LeafletProvider, {
      value: context
    }, props.children);
  }

  return /*#__PURE__*/forwardRef(ContainerComponent);
}
export function createDivOverlayComponent(useElement) {
  function OverlayComponent(props, forwardedRef) {
    var _useState = useState(false),
        isOpen = _useState[0],
        setOpen = _useState[1];

    var instance = useElement(props, setOpen).current.instance;
    useImperativeHandle(forwardedRef, function () {
      return instance;
    });
    useEffect(function updateOverlay() {
      if (isOpen) {
        instance.update();
      }
    }, [instance, isOpen, props.children]); // @ts-ignore _contentNode missing in type definition

    var contentNode = instance._contentNode;
    return contentNode ? /*#__PURE__*/createPortal(props.children, contentNode) : null;
  }

  return /*#__PURE__*/forwardRef(OverlayComponent);
}
export function createLeafComponent(useElement) {
  function LeafComponent(props, forwardedRef) {
    var instance = useElement(props).current.instance;
    useImperativeHandle(forwardedRef, function () {
      return instance;
    });
    return null;
  }

  return /*#__PURE__*/forwardRef(LeafComponent);
}